module.exports = __webpack_public_path__ + "img/about-m-slide-20.58a69b50.jpg";